import { UploadTask, ref, uploadBytesResumable } from 'firebase/storage';
import { patientStorage, videoStorage, publicStorage } from '../constants/firebaseModular';
import { FileUpload } from '../types/Files/FileUpload';
import * as Sentry from '@sentry/browser';

// BUCKET USAGE:
// storage: private storage for patient files (web-console-mideoid-patient on PROD)
// videoStorage: public storage for user video files (web-console-mideoid-videos on PROD)
// publicStorage: public storage for public patient docs like POLST and living will (web-console-mideoid-public on PROD)

export const uploadFile = (payload: FileUpload) => {
  if (!payload.bucket) {
    Sentry.captureMessage('Bucket is required');
    console.error('Bucket is required');
    throw new Error('Bucket is required');
  }
  if (!payload.file) {
    Sentry.captureMessage('File is required');
    console.error('File is required');
    throw new Error('File is required');
  }
  if (payload.path?.length === 0) {
    Sentry.captureMessage('Path is required');
    console.error('Path is required');
    throw new Error('Path is required');
  }
  let storageBucket;
  switch (payload.bucket) {
    case 'patient':
      storageBucket = patientStorage;
      break;
    case 'videos':
      storageBucket = videoStorage;
      break;
    case 'public':
      storageBucket = publicStorage;
      break;
  }

  if (!storageBucket) {
    Sentry.captureMessage('Unable to find storageBucket');
    console.error('Unable to find storageBucket');
    throw new Error('Unable to find storageBucket');
  }
  const storageRef = ref(storageBucket, payload.path);
  if (!storageRef) {
    Sentry.captureMessage('Unable to create storageRef from payload');
    console.error('Unable to create storageRef from payload');
    throw new Error('Unable to create storageRef from payload');
  }
  const task = uploadBytesResumable(storageRef, payload.file) as UploadTask;
  return task;
};
